/*! q-forward.js — Attribution Query Forwarding (v1)
 *
 * Trägt eingehende Marketing-Parameter (utm_*, fbclid, gclid, ttclid, msclkid …)
 * über ALLE Hops bis in den Checkout:
 *     Meta-Ad → Advertorial (veramedico) → Sales Page (shop.fairment.de) → Loop-Checkout
 *
 * - dependency-frei, idempotent, läuft auf Advertorials UND Sales Pages
 * - dekoriert statische Links beim Laden + fängt JS-gesetzte/späte Links per Klick ab
 *   (deckt damit auch den SP-Kaufbutton ab, dessen href erst per JS gesetzt wird)
 * - überschreibt KEINE bereits am Ziel vorhandenen Parameter (z. B. discount=SUBI_ONETIME_10)
 *
 * Einbinden: möglichst früh im <head> auf jeder Seite (Advertorial + Shopify-Store).
 */
(function () {
  'use strict';
  if (window.__qForwardInstalled) return;        // doppelte Einbindung (z. B. inline + GTM) abfangen
  window.__qForwardInstalled = true;

  // Nur Links zu unseren eigenen Properties dekorieren (Substring-Match auf hostname)
  var ALLOW = ['veramedico.com', 'fairment.de', 'myshopify.com'];
  var STORE_KEY = '_attr_q';

  // --- eingehende Attribution-Parameter bestimmen: URL hat Vorrang, sonst sessionStorage ---
  function pickParams() {
    var out = new URLSearchParams();
    var cur = new URLSearchParams(location.search);
    var hasNew = false;
    cur.forEach(function (v, k) { if (v) { out.set(k, v); hasNew = true; } });
    if (hasNew) {
      try { sessionStorage.setItem(STORE_KEY, out.toString()); } catch (e) {}
      return out;
    }
    // keine URL-Parameter (z. B. Reload oder interne Navigation) → gespeicherte derselben Journey
    try {
      var saved = sessionStorage.getItem(STORE_KEY);
      if (saved) return new URLSearchParams(saved);
    } catch (e) {}
    return out; // leer
  }

  var PARAMS = pickParams();
  function isEmpty(p) { var n = 0; p.forEach(function () { n++; }); return n === 0; }
  if (isEmpty(PARAMS)) return;                    // Direktbesuch ohne Tracking → nichts tun

  function allowed(href) {
    if (!href) return false;
    if (/^(#|mailto:|tel:|javascript:)/i.test(href)) return false;
    if (/\/(impressum|datenschutz|agb|widerruf)/i.test(href)) return false;
    var host;
    try { host = new URL(href, location.href).hostname; } catch (e) { return false; }
    for (var i = 0; i < ALLOW.length; i++) if (host.indexOf(ALLOW[i]) > -1) return true;
    return false;
  }

  function decorate(href) {
    try {
      var u = new URL(href, location.href);
      PARAMS.forEach(function (v, k) { if (!u.searchParams.has(k)) u.searchParams.set(k, v); });
      return u.toString();
    } catch (e) { return href; }
  }

  // --- 1. statische Links beim Laden dekorieren ---
  function decorateAll() {
    var as = document.querySelectorAll('a[href]');
    for (var i = 0; i < as.length; i++) {
      var h = as[i].getAttribute('href');
      if (allowed(h)) as[i].setAttribute('href', decorate(h));
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', decorateAll);
  } else {
    decorateAll();
  }

  // --- 2. Klick-Interceptor (capture): fängt auch per JS gesetzte / nachträglich
  //        eingefügte Links ab, z. B. den SP-Kaufbutton (cta.href = plan.link) ---
  document.addEventListener('click', function (e) {
    var a = (e.target && e.target.closest) ? e.target.closest('a[href]') : null;
    if (!a) return;
    var h = a.getAttribute('href');
    if (allowed(h)) a.setAttribute('href', decorate(h));
  }, true);
})();
